export type RelatedParamDefinitions = {
  categoryId: string;
  paramDefinitionId: string;
};
